import { useTranslation } from 'react-i18next'
import CustomButton from '@/components/CustomButton'

interface KycFailedProps {
    onReapply: () => void
}

const KycFailed: React.FC<KycFailedProps> = ({ onReapply }) => {
    const { t } = useTranslation()

    return (
        <div className="mt-6 mx-5">
            <div className="bg-white rounded-2xl p-6 flex flex-col items-center">
                <div className="flex items-center justify-center gap-2 mb-4">
                    <div className="w-5 h-5 rounded-full bg-[#EF454A] flex items-center justify-center">
                        <img src="/images/card-v2/cancel-white.svg" alt="failed" className="w-full h-full" />
                    </div>
                    <span>{t('下卡失败')}</span>
                </div>
                <div className="text-sm text-[#9BA0AF] text-center mb-6">
                    {t('信息未通过，请核对信息后重新填写并提交')}
                </div>
                <CustomButton
                    color='default'
                    onClick={onReapply}
                    className="w-full h-12 bg-[#F2F3F5] rounded-full text-base font-medium text-[#1D2129]"
                >
                    {t('重新填写')}
                </CustomButton>
            </div>
        </div>
    )
}

export default KycFailed
